import * as React from 'react';

import { EFeedbackScreen, ISendFeedbackParams } from '../../types/redux';
import { Feedback as FeedbackComponent, Thanks } from '../../components/Feedback';

export interface IFeedbackProps {
  screen: EFeedbackScreen;
  isLoading: boolean;
  isSendError: boolean;
  isVisibleForm: boolean;
  sendFeedback(params: ISendFeedbackParams): void;
  setDimensionsFeedback(top: number, height: number): void;
}

export function Feedback({
  screen,
  isLoading,
  isSendError,
  sendFeedback,
  isVisibleForm,
  setDimensionsFeedback,
}: IFeedbackProps) {
  if (!isVisibleForm) {
    return null;
  }

  return screen === EFeedbackScreen.Form ? (
    <FeedbackComponent
      isLoading={isLoading}
      isSendError={isSendError}
      sendFeedback={sendFeedback}
      setDimensionsFeedback={setDimensionsFeedback}
    />
  ) : (
    <Thanks />
  );
}
